import http from '../http';
import { cachedGet } from '../cachedGet';

/**
 * Получить список компаний с доступом к flow
 * @param {number} flowId
 * @returns {Promise}
 */
export const getFlowCompanyAccess = (flowId) => {
  return cachedGet(`/flow/${flowId}/company-access`);
};

/**
 * Обновить доступ компаний к flow
 * @param {number} flowId
 * @param {Array} companies - [{ company_id: 1, status: 'active' }, ...]
 * @returns {Promise}
 */
export const updateFlowCompanyAccess = (flowId, companies) => {
  return http.post(`/flow/${flowId}/company-access`, { companies });
};
